export default __webpack_public_path__ + "static/media/icon_record_video_hover.60e7fed5.svg";